<div class="wrapper">
  <div class="content">
      <app-header></app-header>
  </div>
  <router-outlet></router-outlet>
  <div class="footer">
      <app-footer></app-footer>
  </div>
</div>